module.exports = __webpack_public_path__ + "static/img/fish29.7caf1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish29.png
// module id = WkAL
// module chunks = 0